function st_add_to_cart(event) {
  console.log("Adding to cart: ", event.detail.itemId);

  const xhr = new XMLHttpRequest();
  xhr.open("POST", "https://belfurniture.com/cart/add");
  xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");

  const body = JSON.stringify({
    form_type: "product",
    utf8: "✓",
    id: event.detail.itemId
  });

  xhr.onload = () => {
    if (xhr.readyState == 4 && xhr.status == 201) {
      console.log(JSON.parse(xhr.responseText));
    } else {
      console.log(`Error: ${xhr.status}`);
    }
  };
  xhr.send(body);
}

window.onload = () => {
  const stWidget = document.getElementsByTagName("shoptelligence-cui-widget")[0];
  if (stWidget) {
    stWidget.addEventListener("st_add_to_cart", st_add_to_cart, false);
    stWidget.addEventListener("st_dc_add_to_cart", st_add_to_cart, false);

    stWidget.addEventListener("st_save_item", (event) => {
      console.log("Saving to Favorites: ", event.detail.itemId);
    }, false);

    stWidget.addEventListener("st_see_in_store", (event) => {
      console.log("See in store: ", event.detail.itemId);
    }, false);

    stWidget.addEventListener("st_special_offers", (event) => {
      console.log("Special Offers: ", event.detail.itemId);
    }, false);

    const stIframe = stWidget.getElementsByTagName('iframe')[0];
    if (stIframe) stIframe.setAttribute('data-hj-allow-iframe','');
  }

  const dcWidget = document.getElementsByTagName("shoptelligence-dc-widget")[0];
  if (dcWidget) {
    const dcIframe = dcWidget.getElementsByTagName('iframe')[0];
    if (dcIframe) dcIframe.setAttribute('data-hj-allow-iframe','');
  }
};
